<template>
<nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top shadow-sm">
    <div class="container-fluid">
        <div style="font-weight:600;" class="me-2"><i class="bi bi-water"></i> WATER LEVEL</div>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
           <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li v-if="$router.currentRoute.value.path=='/'" class="nav-item  rounded-5 px-2" style="background-color:#5899ACFF;color: white;">
                        <a style="color: white;" class="nav-link active" aria-current="page" href="#"><i class="bi bi-geo"></i> Node List</a>
                    </li>
                    <li class="nav-item" v-else>
                        <router-link to="/" style=" text-decoration: none !important;">
                            <a class="nav-link active" aria-current="page" href="#"><i class="bi bi-geo"></i> Node List</a>
                        </router-link>
                    </li>

                    <li v-if="$router.currentRoute.value.path=='/devices'" class="nav-item  rounded-5 px-2" style="background-color:#5899ACFF;color: white;">
                        <a class="nav-link active" style="color: white;" aria-current="page" href="#"><i class="bi bi-app-indicator"></i> Devices</a>
                    </li>
                    <li class="nav-item" v-else>
                        <router-link to="/devices" style=" text-decoration: none !important;">
                            <a class="nav-link active" aria-current="page" href="#"><i class="bi bi-app-indicator"></i> Devices</a>
                        </router-link>
                    </li>

                    <li v-if="$router.currentRoute.value.path=='/users'" class="nav-item  rounded-5 px-2" style="background-color:#5899ACFF;color: white;">
                                              <a class="nav-link active" style="color: white;" aria-current="page" href="#"><i class="bi bi-people"></i> Users</a>
                    </li>
                    <li class="nav-item" v-else>
                        <router-link to="/users" style=" text-decoration: none !important;">
                            <a class="nav-link active"  aria-current="page" href="#"><i class="bi bi-people"></i> Users</a>
                        </router-link>
                    </li>
                </ul>
            <form class="d-flex">

                <button class="btn btn-outline rounded-5 px-3" style="color: #eb6451; border: 2px solid #eb6451;" type="submit">
                    <i class="bi bi-box-arrow-right" style="font-size: 16px;"></i> <span class="ms-1 " style="font-weight: 400;">logout</span>
                </button>

            </form>
        </div>
    </div>
</nav>
<div class="container-fluid px-2" style="margin-top: 80px;">
    <div class="border rounded-3 py-2 px-3 bg-light w-100">
        <div class="row">
            <div class="col-12 col-md-6 mt-1" style="font-size: 20px;font-weight: bold;">
                <i class="bi bi-people"></i> Users
            </div>
            <div class="col-12 col-md-6 text-end pe-3 mt-1">
                <span>เพิ่มผู้ใช้งานได้ที่นี่ </span>
                <button type="button" class="ms-2 btn btn-dark rounded-5" data-bs-toggle="modal" data-bs-target="#addDeviceModal">+ Add User</button>
            </div>
        </div>
    </div>

    <div class="table-responsive mt-3">
        <table class="table table-sm w-100">
            <thead>
                <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Edit</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in users" :key="item.id">
                    <th scope="row">{{ index+1 }}</th>
                    <td>UID00{{ item.id }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.role }}</td>
                    <td>
                        <i class="bi bi-eye " style="font-size: 18px;"></i>
                        <i class="bi bi-pen ms-2" style="font-size: 18px;"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

</template>

<script>
export default {
    data() {
        return {
            users: [{
                    "id": "1023",
                    "sn": "548921",
                    "name": "สิริกร นิ่มนวล",
                    "role": "admin",
                    "email": "sirikonimnual@example.com",
                    "phone": "0891234567",
                    "location": "กรุงเทพฯ"
                },
                {
                    "id": "2845",
                    "sn": "120984",
                    "name": "วสันต์ เทพทัต",
                    "role": "owner",
                    "email": "wasantthepphat@example.com",
                    "phone": "0819876543",
                    "location": "เชียงใหม่"
                },
                {
                    "id": "3761",
                    "sn": "773201",
                    "name": "กชกร พงษ์ศรี",
                    "role": "user",
                    "email": "kotchakornp@example.com",
                    "phone": "0865551212",
                    "location": "ขอนแก่น"
                },
                {
                    "id": "4982",
                    "sn": "442819",
                    "name": "นิภาพร แก้วดี",
                    "role": "user",
                    "email": "niphapornk@example.com",
                    "phone": "0852223344",
                    "location": "ชลบุรี"
                },
                {
                    "id": "5630",
                    "sn": "991045",
                    "name": "ธนพล รุ่งเรือง",
                    "role": "admin",
                    "email": "thanapolr@example.com",
                    "phone": "0846667788",
                    "location": "นครปฐม"
                },
                {
                    "id": "6784",
                    "sn": "330118",
                    "name": "กุลธิดา วงศ์ไกร",
                    "role": "owner",
                    "email": "kulthidaw@example.com",
                    "phone": "0829991122",
                    "location": "กรุงเทพฯ"
                },
                {
                    "id": "7421",
                    "sn": "664520",
                    "name": "จิรภา เพ็ชรดี",
                    "role": "user",
                    "email": "jirapap@example.com",
                    "phone": "0803334455",
                    "location": "เชียงใหม่"
                },
                {
                    "id": "8950",
                    "sn": "507731",
                    "name": "ปกรณ์ สงวนศักดิ์",
                    "role": "user",
                    "email": "pakorns@example.com",
                    "phone": "0871112233",
                    "location": "ขอนแก่น"
                }
            ]

        }
    },
}
</script>

<style scoped>
    .table-responsive {
    max-width: 100%;
    overflow-x: auto; /* scroll แนวนอนบนมือถือ */
}

.w-100 {
    width: 100% !important;
}

</style>
